import axios from 'axios'
import { i18n } from '../../../plugins/i18n'
import {
  setFormValues,
  setFilterValues,
  toggleFilterValues,
} from '../../../modules/mutations.js'

export const companiesAnalysisKeywords = {
  namespaced: true,
  state: {
    data: {
      keywords: [],
      specifyKeywords: [],
      storeComparisonKeywords: []
    },
    loading: false,
    formValues: {},
    filteredCount: 0,
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    setValuesForFilter(state, payload) {
      state.filteredCount = payload.data.review_total_count
    },
    setValuesForComparisonFilter(state, payload) {
      let count = 0
      payload.data.forEach(keyword => {
        count += keyword.total_count
      })
      state.filteredCount = count
    },
    readAnalysisKeywordsSuccess(state, payload) {
      state.data = {
        keywords: payload.data.keywords,
        specifyKeywords: payload.data.specify_keywords,
      }
      state.loading = false
    },
    readAnalysisComparisonKeywordsSuccess(state, payload) {
      state.data = {
        storeComparisonKeywords: payload.data.map(v => {
          return {
            id: v.id,
            competitor: {
              totalCount: v.competitor.total_count,
              positiveCount: v.competitor.positive_count,
              negativeCount: v.competitor.negative_count,
              brands: v.competitor.brands.sort((a, b) => a.id - b.id).map(v => {
                return {
                  id: v.id,
                  name: v.name,
                  totalCount: v.total_count,
                  positiveCount: v.positive_count,
                  negativeCount: v.negative_count,
                }
              })
            },
            store: {
              totalCount: v.store.total_count,
              positiveCount: v.store.positive_count,
              negativeCount: v.store.negative_count,
              brands: v.store.brands.sort((a, b) => a.id - b.id).map(v => {
                return {
                  id: v.id,
                  name: v.name,
                  totalCount: v.total_count,
                  positiveCount: v.positive_count,
                  negativeCount: v.negative_count,
                }
              })
            },
          }
        })
      }
      state.loading = false
    },
    apiFailure(state) {
      state.loading = false
    },
    createIgnoreSuccess(state, rule) {
      state.data.keywords = state.data.keywords.filter(function(value){
        return value.id != rule
      })
      state.loading = false
    },
    exportCsvSuccess(state){
      state.loading = false
    },
    setFormValues,
    setFilterValues,
    toggleFilterValues,
  },
  actions: {
    readAnalysisKeywordsForFilter({ commit, rootState }, payload) {
      return axios
        .post(
          '/api/companies/' + rootState.route.params.company_uuid + '/analysis/keywords.json',
          payload
        )
        .then(res => {
          commit('setValuesForFilter', res.data)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    readAnalysisComparisonKeywordsForFilter({ commit, rootState }, payload) {
      return axios
        .post(
          '/api/companies/' + rootState.route.params.company_uuid + '/analysis/keywords_compare.json',
          payload
        )
        .then(res => {
          commit('setValuesForComparisonFilter', res.data)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    readAnalysisKeywords({ commit, state }, { companyUuid, query }) {
      if (state.loading) return

      commit('prepareConnect')
      return axios
        .post(
          '/api/companies/' + companyUuid + '/analysis/keywords.json',
          query
        )
        .then((res) => {
          commit('readAnalysisKeywordsSuccess', res.data)
          commit('setValuesForFilter', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    readAnalysisComparisonKeywords({ commit }, { companyUuid, query }) {
      commit('prepareConnect')
      return axios
        .post('/api/companies/' + companyUuid + '/analysis/keywords_compare.json', query)
        .then((res) => {
          commit('readAnalysisComparisonKeywordsSuccess', res.data)
          commit('setValuesForComparisonFilter', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    setFormValues({ commit }, values) {
      commit('setFormValues', values)
    },
    createIgnore({ commit }, { company_uuid, payload }) {
      commit('prepareConnect')
      return axios
        .post('/api/companies/' + company_uuid + '/analysis/settings/ignores' + '.json', payload)
        .then(() => {
          commit('createIgnoreSuccess', payload.rule)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('pages.CompaniesReviews.SettingKeywordModal.message.ignored') }, { root: true })
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    exportCsv({ commit, state }, { companyUuid, query }) {
      if (state.loading) return false

      commit('prepareConnect')
      return axios
        .post(
          '/api/companies/' + companyUuid + '/export/analysis/keywords.json',
          query
        )
        .then(() => {
          commit('exportCsvSuccess')
          return true
        })
        .catch(err => {
          console.log({err})
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
  },
}
